export const isValidEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

export const isValidWebsite = (url: string) => {
    const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
    return regex.test(url);
};

export const isValidPhoneNumber = (phone: string) => {
    const regex = /^\d{7,15}$/; // allows 7–15 digits
    return regex.test(phone);
};

export const isArray = (value: any): boolean => {
    return Array.isArray(value);
};

export const isObject = (value: any): boolean => {
    return value !== null && typeof value === 'object';
};
